import React from "react";

const DropdownIcon = ({
  width = 9,
  height = 6,
  color = "#BC6B38",
  className = "",
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 9 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M3.96094 5.03906L0.210938 1.28906C-0.0703125 0.984375 -0.0703125 0.515625 0.210938 0.210938C0.515625 -0.0703125 0.984375 -0.0703125 1.28906 0.210938L4.5 3.44531L7.71094 0.210938C8.01562 -0.0703125 8.48438 -0.0703125 8.78906 0.210938C9.07031 0.515625 9.07031 0.984375 8.78906 1.28906L5.03906 5.03906C4.73438 5.32031 4.26562 5.32031 3.96094 5.03906Z"
        fill={color}
      />
    </svg>
  );
};

export default DropdownIcon;